import Vue from 'vue'

const hub = new Vue()

export const InfoMessage = {
  positive: (text)=>{
    hub.$emit('openMessageController', 'success' , text);
  },
  negative: (text)=>{
    hub.$emit('openMessageController', 'error' , text);
  },
  info: (text)=>{
    hub.$emit('openMessageController', 'info' , text);
  }
}

export default hub;
